/** Shared categorical palette for canvas-based Chart.js visualizations. */
export const chartColors = [
  '#480A77',
  '#8075FF',
  '#89E8F1',
  '#FA198B',
  '#4BC6B9',
  '#F0EFF4',
  '#D1CFE2',
  '#BAA898',
] as const;
